import React, { useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

const pages = [
  "/champaransatyagrah/page1.jpg",
  "/champaransatyagrah/page2.jpg",
  "/champaransatyagrah/page3.jpg",
  "/champaransatyagrah/page4.jpg",
  "/champaransatyagrah/page5.jpg",
  "/champaransatyagrah/page6.jpg",
  "/champaransatyagrah/page7.jpg",
  "/champaransatyagrah/page8.jpg",
  "/champaransatyagrah/page9.jpg",
];

export default function Champaran_Satyagrah() {
  const book = useRef(null);
  const [page, setPage] = useState(1);

  const nextPage = () => {
    book.current?.pageFlip().flipNext();
  };

  const prevPage = () => {
    book.current?.pageFlip().flipPrev();
  };

  return (
    <>
    <Helmet>
      <title>Champaran Satyagrah | Gandhi Mandela Foundation</title>
    </Helmet>
      <Header />

      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Champaran Satyagrah</span>
          </div>
          <h1>Champaran Satyagrah</h1>
        </div>
      </section>

      <section className="section">
        <div className="container flipbook-container">

          <HTMLFlipBook
            ref={book}
            width={600}
            height={600}
            size="stretch"
            minWidth={280}
            maxWidth={700}
            minHeight={500}
            maxHeight={900}
            showCover={true}
            mobileScrollSupport={true}
            drawShadow={true}
            onFlip={(e) => setPage(e.data + 1)}
          >
            {pages.map((img, index) => (
              <div className="book-page" key={index}>
                <img src={img} alt={`Page ${index + 1}`} />

                <div className="page-corner top">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>

                <div className="page-corner bottom">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
              </div>
            ))}
          </HTMLFlipBook>

          <div className="page-count">
            Page {page} of {pages.length}
          </div>

          <div className="swipe-hint">
            <i className="fa-solid fa-hand-point-up"></i>
            Swipe or use the buttons below to turn pages
          </div>

          <div className="mobile-controls">
            <button onClick={prevPage}>
              <i className="fa-solid fa-chevron-left"></i> Previous
            </button>

            <button onClick={nextPage}>
              Next <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}